import lightGallery from "lightgallery";
import "lightgallery/css/lightgallery-bundle.min.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import "lightgallery/css/lg-thumbnail.css";
import "./box-gallery.scss";

const boxGallery = () => {
    let allBoxGallery = document.querySelectorAll(".im-gallery");

    if (!allBoxGallery.length) return;

    allBoxGallery.forEach((el) => {
        let thisGallery = el.querySelector(".im-gallery__lightgallery");
        let openGallery = el.querySelector(".im-gallery__media");

        if (thisGallery) {
            lightGallery(thisGallery, {
                thumbnail: true,
                plugins: [lgThumbnail],
                exThumbImage: "data-exthumbimage",
                animateThumb: true,
                // thumbnail: false,
                // animateThumb: false,
                // showThumbByDefault: false,
                mobileSettings: {
                    showCloseIcon: true,
                },
                download: false,
                hideBarsDelay: 1000000000,
                autoplayControls: false,
                hash: false,
                escKey: true,
                keyPress: true,
                licenseKey: "WQ63Z-598QW-NZ7D5-WPMTB",
            });

            openGallery.addEventListener("click", (evt, el) => {
                evt.preventDefault();
                thisGallery.querySelector("li:first-child").click();
            });
        }
    });
};

export default boxGallery;
